import { CURRENCY_LABEL_OPTIONS } from '@modules/consolidator/utils/Currency/Currency.js'

export const ASSET_FORM_PURCHASE_MODE = {
  VALOR: 'Valor',
  QUANTIDADE: 'Quantidade',
}

export const ASSET_FORM_PURCHASE_MODES = [
  ASSET_FORM_PURCHASE_MODE.VALOR,
  ASSET_FORM_PURCHASE_MODE.QUANTIDADE,
]

export const ASSET_FORM_MOVEMENT_TYPE_OPTIONS = [
  { text: 'Compra', value: 'compra' },
  { text: 'Venda', value: 'venda' },
]

export const ASSET_FORM_FIELD_CATALOG = {
  id_conta: {
    id: 'id_conta',
    label: 'Selecione a conta do cliente',
    type: 'select-investment-account',
    cols: 12,
    placeholder: 'Selecionar',
  },
  nome_ativo: {
    id: 'nome_ativo',
    label: 'Selecione o ativo',
    type: 'select-asset',
    cols: 6,
    placeholder: 'Selecionar',
    props: {
      outlined: true,
      clearable: true,
      selectClass: 'new-ux',
    },
  },
  referencia: {
    id: 'referencia',
    label: 'Moeda',
    type: 'select',
    cols: 6,
    placeholder: 'Selecionar',
    hideWhenEditing: true,
    props: {
      clearable: true,
    },
  },
  moeda: {
    id: 'moeda',
    label: 'Moeda',
    type: 'select',
    cols: 6,
    placeholder: 'Selecionar',
    options: CURRENCY_LABEL_OPTIONS,
    props: { clearable: false },
  },
  CI: {
    id: 'CI',
    label: 'Classe',
    type: 'select-class',
    cols: 6,
    placeholder: 'Selecionar',
  },
  categoria: {
    id: 'categoria',
    label: 'Selecione a categoria',
    type: 'select-rf-category',
    cols: 6,
    placeholder: 'Selecionar',
  },
  modo_compra: {
    id: 'modo_compra',
    label: 'Modo de compra',
    type: 'select',
    cols: 6,
    placeholder: 'Selecionar',
    hideWhenEditing: true,
  },
  saldo_bruto: {
    id: 'Saldo Bruto',
    label: 'Valor aplicado inicial',
    type: 'money',
    cols: 6,
    placeholder: '0,00',
    hideWhenEditing: true,
  },
  pu: {
    id: 'pu',
    label: 'Preço unitário',
    type: 'money',
    cols: 4,
    placeholder: '0,00',
    hideWhenEditing: true,
  },
  quantidade: {
    id: 'quantidade',
    label: 'Quantidade adquirida',
    cols: 4,
    type: 'number',
    placeholder: '0',
    hideWhenEditing: true,
  },
  data_aplicacao_inicial: {
    id: 'data_aplicacao_inicial',
    label: 'Data de aplicação',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
    hideWhenEditing: true,
  },
  data_cotizacao_inicial: {
    id: 'data_cotizacao_inicial',
    label: 'Data de cotização inicial',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
    dependsOn: 'data_aplicacao_inicial',
    hideWhenEditing: true,
  },
  dataVencimento: {
    id: 'dataVencimento',
    label: 'Data de vencimento',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
  },
  emissor: {
    id: 'emissor',
    label: 'Emissor',
    type: 'text',
    cols: 6,
    placeholder: '',
  },
  subclasse: {
    id: 'subclasse',
    label: 'Subclasse',
    type: 'select-subclass',
    cols: 12,
    placeholder: 'Selecionar',
  },
  fundo_cnpj: {
    id: 'fundo_cnpj',
    label: 'CNPJ Fundo',
    type: 'text',
    cols: 6,
    placeholder: '',
  },
  fundo_subclasse: {
    id: 'fundo_subclasse',
    label: 'ID Subclasse (Fundo)',
    type: 'text',
    cols: 6,
    placeholder: '',
  },
  nome_portfolio: {
    id: 'nome_portfolio',
    label: 'Portfólio',
    type: 'select-portfolio',
    cols: 12,
    placeholder: 'Selecionar',
  },
  ativo_iliquido: {
    id: 'ativo_iliquido',
    label: 'Ativo ilíquido',
    type: 'checkbox',
    cols: 12,
  },
  isento: {
    id: 'isento',
    label: 'Isento de IR',
    type: 'checkbox',
    cols: 12,
  },
  data_carencia: {
    id: 'data_carencia',
    label: 'Data de carência',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
  },
  carencia_diaria: {
    id: 'carencia_diaria',
    label: 'Carência diária',
    type: 'checkbox',
    cols: 6,
  },
  rating: {
    id: 'rating',
    label: 'Rating',
    type: 'select',
    cols: 6,
    placeholder: 'Selecionar',
  },
  conta_rentavel: {
    id: 'conta_rentavel',
    label: 'Conta é rentável',
    type: 'select',
    cols: 12,
    placeholder: 'Selecionar',
    options: ['Sim', 'Não'],
    props: {
      clearable: false,
    },
  },
  taxa: {
    id: 'taxa',
    label: 'Taxa',
    type: 'percent',
    cols: 4,
    placeholder: '0,0000%',
  },
  indexador: {
    id: 'indexador',
    label: 'Selecione o indexador',
    type: 'select',
    cols: 4,
    placeholder: 'Selecionar',
  },
  marcacao_na_curva: {
    id: 'marcacao_na_curva',
    label: 'Modo de cotização',
    type: 'asset-cotizacao-mode',
    cols: 12,
  },
  com_cupom: {
    id: 'com_cupom',
    label: 'Possui pagamento de cupom',
    type: 'checkbox',
    cols: 12,
  },
  cupom_inicio: {
    id: 'cupom_inicio',
    label: 'Data de início do pagamento',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
  },
  cupom_periodicidade_em_meses: {
    id: 'cupom_periodicidade_em_meses',
    label: 'Periodicidade de pagamento',
    type: 'number',
    cols: 6,
    placeholder: '0',
  },
  com_amortizacao: {
    id: 'com_amortizacao',
    label: 'Possui amortização',
    type: 'checkbox',
    cols: 12,
  },
  amortizacao_inicio: {
    id: 'amortizacao_inicio',
    label: 'Data de início da amortização',
    type: 'date',
    cols: 6,
    placeholder: 'DD/MM/AAAA',
  },
  amortizacao_periodicidade_em_meses: {
    id: 'amortizacao_periodicidade_em_meses',
    label: 'Periodicidade da amortização',
    type: 'number',
    cols: 6,
    placeholder: '0',
  },
  tags: {
    id: 'tags',
    label: 'Tags',
    type: 'input-tags',
    cols: 12,
  },
  comentarios: {
    id: 'comentarios',
    label: 'Comentários:',
    type: 'textarea',
    cols: 12,
    props: { 'hide-details': true },
  },
  modoCompraRV: {
    id: 'modoCompraRV',
    label: 'Tipo de movimentação',
    type: 'select',
    cols: 4,
    placeholder: 'Selecionar',
    hideWhenEditing: true,
    props: {
      'item-text': 'text',
      'item-value': 'value',
    },
  },
  impostos: {
    id: 'impostos',
    label: 'Impostos',
    type: 'money',
    cols: 4,
    placeholder: '0,00',
    hideWhenEditing: true,
  },
  taxas: {
    id: 'taxas',
    label: 'Taxas',
    type: 'money',
    cols: 4,
    placeholder: '0,00',
    hideWhenEditing: true,
  },
  cotacao: {
    id: 'cotacao',
    label: 'Câmbio',
    type: 'money',
    cols: 4,
    placeholder: '0,00',
    hideWhenEditing: true,
  },
  cusip: {
    id: 'cusip',
    label: 'CUSIP',
    cols: 6,
    placeholder: '',
  },
  isin: {
    id: 'isin',
    label: 'ISIN',
    cols: 6,
    placeholder: '',
  },
}
